/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setIndividualTaxInformation} from '../api'

export const useMutationSetIndividualTaxInformation = createReactQueryMutationHook('setIndividualTaxInformation', setIndividualTaxInformation)
